// extracted by mini-css-extract-plugin
module.exports = {"embedCopyTextarea":"embedCopyTextarea___2GDyG","embedFeedback":"embedFeedback___2WkNl","embedCopied":"embedCopied___1Lp_h"};